"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-block;\n  visibility: hidden;\n  z-index: -1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMeasureElements = exports.useMeasureElement = exports.useMeasureItem = exports.useMeasureCache = exports.MeasureCache = void 0;

var react_1 = __importDefault(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var ThemeContext_1 = require("./ThemeContext");

var log_1 = require("./log");

var styledTypes_1 = require("./styledTypes");

function measureElement(theme, element, measureLayer) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      wrapper = _ref.wrapper;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var child;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!measureLayer) {
              _context.next = 6;
              break;
            }

            child = document.createElement('div');
            measureLayer.appendChild(child);
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              react_dom_1.default.render(react_1.default.createElement(ThemeContext_1.ThemeContext.Provider, {
                value: theme
              }, react_1.default.createElement(ThemeContext_1.ThemeProvider, null, wrapper ? wrapper(element) : element)), child, function () {
                var height = child.clientHeight;
                var width = child.clientWidth;
                react_dom_1.default.unmountComponentAtNode(child);
                child.remove();
                resolve({
                  height: height,
                  width: width
                });
              });
            }));

          case 6:
            return _context.abrupt("return", null);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

var MeasureCache = /*#__PURE__*/function () {
  function MeasureCache(onUpdate) {
    _classCallCheck(this, MeasureCache);

    this.$cache = {};
    this.$onUpdate = onUpdate;
  }

  _createClass(MeasureCache, [{
    key: "measureElement",
    value: function measureElement(id, element) {
      if (this.$cache[id]) return;
      (0, log_1.debug)('measuring element %d', id);
      var oldHeight = element.style.height;
      element.style.height = 'auto';
      this.$cache[id] = {
        width: element.offsetWidth,
        height: element.offsetHeight
      };
      element.style.height = oldHeight;

      if (this.$onUpdate) {
        this.$onUpdate();
      }
    }
  }, {
    key: "at",
    value: function at(id) {
      return this.$cache[id] || null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.$cache = {};

      if (this.$onUpdate) {
        this.$onUpdate();
      }
    }
  }]);

  return MeasureCache;
}();

exports.MeasureCache = MeasureCache;

function useMeasureCache(deps, onUpdate) {
  var cacheRef = react_1.default.useRef(new MeasureCache(onUpdate));
  react_1.default.useEffect(function () {
    cacheRef.current.clear();
  }, deps);
  return cacheRef.current;
}

exports.useMeasureCache = useMeasureCache;

function useMeasureItem(cache, id, ref) {
  var containerRef = react_1.default.useRef(null);
  var realRef = ref || containerRef;
  react_1.default.useEffect(function () {
    if (realRef.current) {
      cache.measureElement(id, realRef.current);
    }
  }, [id]);
  return realRef;
}

exports.useMeasureItem = useMeasureItem;

function useMeasureElement(opts) {
  var containerRef = react_1.default.useRef(null);
  var theme = react_1.default.useContext(ThemeContext_1.ThemeContext);

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      ready = _react_1$default$useS2[0],
      setReady = _react_1$default$useS2[1];

  return {
    container: react_1.default.createElement(Container, {
      ref: function ref(c) {
        containerRef.current = c;
        setReady(!!c);
      }
    }),
    ready: ready,
    measure: function measure(element) {
      return measureElement(theme, element, containerRef.current, opts);
    }
  };
}

exports.useMeasureElement = useMeasureElement;

function useMeasureElements(elements, deps) {
  var _this = this;

  var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var cacheKey = _a.cacheKey,
      rest = __rest(_a, ["cacheKey"]);

  var _react_1$default$useS3 = react_1.default.useState(null),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      measurements = _react_1$default$useS4[0],
      setMeasurements = _react_1$default$useS4[1];

  var cache = react_1.default.useRef({});
  var didMount = react_1.default.useRef(false);
  react_1.default.useEffect(function () {
    if (didMount.current) {
      (0, log_1.debug)('clearing useMeasureElements() cache');
      cache.current = {};
    }

    didMount.current = true;
  }, [cacheKey]);

  var _useMeasureElement = useMeasureElement(rest),
      ready = _useMeasureElement.ready,
      container = _useMeasureElement.container,
      measure = _useMeasureElement.measure;

  react_1.default.useEffect(function () {
    if (ready) {
      var cancel = false;
      var cached = 0;
      (0, log_1.debug)('measuring elements');
      Promise.all(elements.map(function (element) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var elementKey, measureResult;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  elementKey = element.key;

                  if (!(elementKey && cache.current[elementKey])) {
                    _context2.next = 4;
                    break;
                  }

                  cached++;
                  return _context2.abrupt("return", cache.current[elementKey]);

                case 4:
                  _context2.next = 6;
                  return measure(element);

                case 6:
                  measureResult = _context2.sent;
                  if (elementKey) cache.current[elementKey] = measureResult;
                  return _context2.abrupt("return", measureResult);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      })).then(function (measurements) {
        if (!cancel) {
          (0, log_1.debug)('done measuring elements (found %d in cache)', cached);
          setMeasurements(measurements);
        }
      });
      return function () {
        cancel = true;
      };
    } else {
      setMeasurements(null);
    }
  }, [].concat(_toConsumableArray(deps), [ready, cacheKey]));
  return {
    container: container,
    measurements: measurements
  };
}

exports.useMeasureElements = useMeasureElements;
var Container = styledTypes_1.styled.div(_templateObject());